import { decimalMask } from 'commons/utils/mask'
import { useFormContext, useWatch } from 'react-hook-form'

import * as S from './styles'

interface SubtotalProps {
  colorName: string
}

const Subtotal = ({ colorName }: SubtotalProps) => {
  const { control } = useFormContext()

  const line: { [y: string]: number } = useWatch({
    control: control,
    name: `[${colorName}]`,
  })

  const subTotalValue =
    Object.values(line)?.reduce((accumulator, value) => {
      return accumulator + Number(value)
    }, 0) || 0

  return <S.SubtotalText value={subTotalValue}>{decimalMask(subTotalValue)}</S.SubtotalText>
}

export default Subtotal
